import url from 'url'
import { loadScript } from 'shared/dom'

export default class FacebookSDK {

  constructor (config) {
    this.FB = this._initScript(config)
  }

  async _initScript ({ appId, siteDomain, version, src = '//connect.facebook.net/en_US/sdk.js' }) {
    await loadScript(src)

    window.FB.init({
      appId: appId,
      channelUrl: url.resolve(siteDomain, '/public/html/channel.html'),
      status: true,
      cookie: true,
      xfbml: true,
      version: `v${version}`,
    })

    return window.FB
  }

  /**
   * Promisify Facebook's getLoginStatus method
   * @return {Promise}
   */
  async getLoginStatus () {
    const FB = await this.FB
    return new Promise((resolve) => FB.getLoginStatus(resolve))
  }

  /**
   * Promisify Facebook's login method
   * @return {Promise}
   */
  async login () {
    const FB = await this.FB
    const permissions = 'public_profile,publish_actions,email,user_birthday'

    return new Promise((resolve, reject) => {
      FB.login((response) => {
        if (response.authResponse) {
          resolve(response)
        } else {
          reject(response)
        }
      }, {
        scope: permissions,
      })
    })
  }

  async getSelf (token) {
    const FB = await this.FB
    const permissions = 'email,birthday,first_name,last_name,gender'

    return new Promise((resolve, reject) => {
      FB.api('/me', 'GET', {
        access_token: token,
        fields: permissions,
      }, (response) => {
        if (!response || response.error) {
          reject(response)
        } else {
          resolve(response)
        }
      })
    })
  }

  async postToFacebook (params) {
    const FB = await this.FB
    return new Promise((resolve, reject) => {
      FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          FB.ui(params)
          resolve()
        } else {
          FB.login((loginResponse) => {
            if (loginResponse.authResponse) {
              FB.ui(params)
              resolve()
            } else {
              reject()
            }
          })
        }
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/shared/facebook.js